<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content pt-15">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20">
        <div class="bold9 size20 color1">
          我参与的-竞价详情
          <!-- <span style="font-size: 14px; color: #ccd9e9">
            Bidding Hall</span
          > -->
        </div>
        <div class="color-aaa color2" style="margin-top: 4px">
          <!-- 浏览量{{ jingJiaDetail.views }} -->
        </div>
      </div>
      <!-- 竞价公告 -->
      <div style="margin-top: 46px">
        <div
          style="
            font-size: 14px;
            color: #3b426b;
            margin-bottom: 14px;
            font-weight: bold;
          "
        >
          成交结果公告
        </div>
        <el-descriptions
          :column="2"
          border
          labelClassName="my-label"
          contentClassName="my-content"
        >
          <el-descriptions-item
            label="竞价标题"
            label-class-name="my-label"
            content-class-name="my-content"
            >{{ jingJiaDetail.title }}</el-descriptions-item
          >
          <el-descriptions-item label="发布单位">{{
            jingJiaDetail.publishCompany
          }}</el-descriptions-item>
          <el-descriptions-item label="场次号">{{
            jingJiaDetail.sessionNum
          }}</el-descriptions-item>
          <el-descriptions-item label="最终用户">{{
            jingJiaDetail.finalUser
          }}</el-descriptions-item>
          <el-descriptions-item label="竞价开始时间">{{
            jingJiaDetail.beginTime
          }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{
            jingJiaDetail.linker
          }}</el-descriptions-item>
          <el-descriptions-item label="竞价结束时间">{{
            jingJiaDetail.endTime
          }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{
            jingJiaDetail.linkMode
          }}</el-descriptions-item>
          <el-descriptions-item label="来源">{{
            jingJiaDetail.source
          }}</el-descriptions-item>
          <el-descriptions-item label="付款方式">{{
            jingJiaDetail.payMode == 1 ? "一次性付清" : "阶段性付清"
          }}</el-descriptions-item>
          <el-descriptions-item label="参与方式">{{
            jingJiaDetail.participationMode == 1 ? "公开" : "非公开"
          }}</el-descriptions-item>
          <el-descriptions-item label="出价方式">{{
            jingJiaDetail.biddingMode == 1 ? "连续报价" : "连续报价"
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="附件">
            <div class="pointer" @click="upload">下载</div>
          </el-descriptions-item> -->
        </el-descriptions>
      </div>
      <!-- 竞价产品明细 -->
      <div style="margin-top: 30px">
        <div
          style="
            font-size: 14px;
            color: #3b426b;
            margin-bottom: 14px;
            font-weight: bold;
          "
        >
          竞价产品明细
        </div>
        <!-- 表格 -->
        <el-table
          :header-cell-style="{
            background: '#3B426C',
            color: '#ffffff',
            padding: '0px',
            height: '40px',
          }"
          :cell-style="{ padding: '0px' }"
          :row-style="{ height: '40px' }"
          class="table2 mb-10"
          :data="tableData2"
          stripe
          style="font-size: 14px"
        >
          <el-table-column prop="subTitle" label="分包标题" align="center">
            <template></template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" align="center">
            <template></template>
          </el-table-column>
          <el-divider direction="vertical"></el-divider>
          <el-table-column prop="productSpec" label="规格型号" align="center">
          </el-table-column>
          <el-table-column prop="specReplace" label="型号可替代" align="center">
          </el-table-column>
          <el-table-column prop="purchaseNum" label="采购数量" align="center">
          </el-table-column>
          <el-table-column prop="unit" label="计量单位" align="center">
          </el-table-column>
          <el-table-column prop="arrivalDate" label="到货日期" align="center">
          </el-table-column>
          <el-table-column prop="arrivalPlace" label="到货地点" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 30px">
        <div
          style="
            font-size: 14px;
            color: #3b426b;
            margin-bottom: 14px;
            font-weight: bold;
          "
        >
          报价记录
        </div>
        <!-- 表格 -->
        <el-table
          :header-cell-style="{
            background: '#3B426C',
            color: '#ffffff',
            padding: '0px',
            height: '40px',
          }"
          :cell-style="{ padding: '0px' }"
          :row-style="{ height: '40px' }"
          class="table2 mb-10"
          :data="jiLuList"
          stripe
          style="font-size: 14px"
        >
          <el-table-column prop="bidderNum" label="报价人序号" align="center">
            <template slot-scope="scope">
              {{ scope.row.bidderNum }}号报价人
            </template>
          </el-table-column>
          <el-table-column
            prop="supplierName"
            label="供应商名称"
            align="center"
          >
            <template></template>
          </el-table-column>
          <el-table-column prop="bidAmount" label="报价金额" align="center">
            <template></template>
          </el-table-column>
          <el-divider direction="vertical"></el-divider>
          <el-table-column prop="bidTime" label="报价时间" align="center">
          </el-table-column>
        </el-table>
      </div>
      <!-- 按钮 -->
      <!-- <div class="btn" @click="jingjia">我要竞价</div> -->
    </div>

    <Footer class="mt-15" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  components: { Footer },

  data() {
    return {
      message: "155,432",
      tableData: [],
      tableData2: [],
      total: "",
      bid: window.sessionStorage.getItem("jjId"),
      jingJiaDetail: {},
      jiLuList: [],
    };
  },
  mounted() {
    this.getJingJiaDetail();
    this.getBaoJiaList();
  },
  methods: {
    //获取分包详情
    //获取竞价详情
    async getJingJiaDetail() {
      const { data: res } = await this.$axios.get(
        `/api/biddingInfo/getBiddingDetail`,
        {
          params: {
            biddingId: this.bid,
            userId: window.sessionStorage.getItem("userId"),
          },
        }
      );
      if (res.code == 200) {
        this.jingJiaDetail = res.data;
        this.tableData2 = [];
        res.data.subDetailList.some((item) => {
          let obj = {};
          if (item.productList.length > 0) {
            obj.id = item.id;
            obj.subTitle = item.subTitle;
            item.productList.some((subItem) => {
              obj.productName = subItem.productName;
              obj.productSpec = subItem.productSpec;
              obj.specReplace = subItem.specReplace;
              obj.purchaseNum = subItem.purchaseNum;
              obj.unit = subItem.unit;
              obj.arrivalDate = subItem.arrivalDate;
              obj.arrivalPlace = subItem.arrivalPlace;
              obj.remark = subItem.remark;
            });
          }

          this.tableData2.push(obj);
        });
      } else {
        console.log(res.msg);
        return;
      }
    },
    //获取报价记录
    async getBaoJiaList() {
      const { data: res } = await this.$axios.get(
        "/api/biddingInfo/getQuoteRecord",
        {
          params: {
            biddingId: this.bid,
            supplierId: window.sessionStorage.getItem("supplierId"),
          },
          headers: {
            token: window.sessionStorage.getItem("token"),
          },
        }
      );
      console.log(res);
      if (res.code == 200) {
        this.jiLuList = res.data;
      }
    },
    jingjia() {
      window.sessionStorage.setItem("jjId", this.jingJiaDetail.id);
      window.sessionStorage.setItem("jjStatus", this.jingJiaDetail.status);
      this.$router.push("/jjxz");
    },
    upload() {
      this.$message.closeAll();
      this.$message.success("下载成功");
    },
  },
};
</script>
<style lang="less">
.my-label {
  width: 200px;
  text-align: center !important;
  font-weight: bold !important;
  border: 1px solid #ccd9e9 !important;
  color: #3b426b !important;
}
.my-content {
  text-align: center !important;
  border: 1px solid #ccd9e9 !important;
  color: #3b426b !important;
}
.el-descriptions__body {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
  .jingjia-box {
    .row {
      height: 46px;
      line-height: 46px;
      color: #3b426b;
      .col {
        width: 180px;
        border: 1px solid #ccd9e9;
        border-right: none;
        text-align: center;
      }
      .col2 {
        width: 180px;
        border: 1px solid #ccd9e9;
        border-right: none;
        text-align: center;
      }
      .col1 {
        width: 420px;
        border: 1px solid #ccd9e9;
        border-right: none;
        text-align: center;
        .blue-color {
          color: #1c65c4;
        }
      }
      .col3 {
        width: 420px;
        border: 1px solid #ccd9e9;
        text-align: center;
      }
    }
  }
}
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
/deep/.table2.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
/deep/.table2.el-table .cell {
  border-right: 1px solid #95b3db;
}
/deep/.table2.el-table td.el-table__cell {
  border-bottom: none;
}
.btn {
  margin: auto;
  width: 120px;
  height: 40px;
  border-radius: 25px;
  margin-top: 36px;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  background-color: #1c65c4;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
</style>